import { render, staticRenderFns } from "./roadmap_shell.vue?vue&type=template&id=29a8aa85"
import script from "./roadmap_shell.vue?vue&type=script&lang=js"
export * from "./roadmap_shell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports